import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BasketSupplierItemComponent } from './basket-supplier-item/basket-supplier-item.component';
import { BasketSupplierItemUiModule } from '@lib/basket/suppliers-basket/basket-supplier/basket-supplier-item/ui';

@NgModule({
    imports: [CommonModule, BasketSupplierItemUiModule],
    declarations: [BasketSupplierItemComponent],
    exports: [BasketSupplierItemComponent],
})
export class BasketSupplierItemFeatureModule {}
